import inserted from '@mailobj-browser/front/js/tree/inserted.js'
import { removed } from '@mailobj-browser/front/js/tree/tree.js'
import { elements } from '../../../styles.js'
import * as sharedClasses from '#utilities/js/ea/sharedClasses.js'

export default container => {
  const { ownerDocument, dataset } = container
  const { prefPreview } = dataset
  const { body } = ownerDocument
  let prefClass

  if (prefPreview) {
    prefClass = prefPreview === '1' ? elements.message_preview_under : elements.message_preview_side
  }

  queueMicrotask(async () => {
    // @todo FB A supprimer quand web2 et default seront fusionnés
    await inserted(container, body)
    sharedClasses.add(container, elements.message)
    if (prefClass) {
      sharedClasses.add(container, prefClass)
    }
  })

  queueMicrotask(async () => {
    // @todo FB A supprimer quand web2 et default seront fusionnés
    await removed(container)
    sharedClasses.remove(container, elements.message)
    if (prefClass) {
      sharedClasses.remove(container, prefClass)
    }
  })
}
